import React from "react"
import PropTypes from "prop-types"
import { Flex, Button } from "antd"
import { useTranslation, Trans } from "react-i18next"
import { Modal } from "ui/Modal"
import { Text } from "ui/Typography"
import { colors } from "themes/variables"
import BookingCard from "./components/BookingCard"
import styles from "./index.module.css"

const BookingConflictModal = ({
  open,
  onCancel,
  bookings = [],
  crewMemberName,
  titleKey = "crewMember.scheduledTimeOff.bookingConflictList.title",
  messageKey = "crewMember.scheduledTimeOff.bookingConflictList.message",
  closeButtonKey = "crewMember.scheduledTimeOff.buttons.close"
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={t(titleKey)}
      width={700}
      centered
      footer={[
        <Button key="close" type="primary" onClick={onCancel}>
          {t(closeButtonKey)}
        </Button>
      ]}
    >
      <Flex vertical gap={16}>
        {/* Message */}
        <Text color={colors.textSecondary}>
          <Trans
            i18nKey={messageKey}
            values={{ crewMemberName }}
            components={{ bold: <Text fw={500} /> }}
          />
        </Text>

        {/* Bookings List */}
        <Flex vertical gap={12} className={styles.bookingsList}>
          {bookings.map((booking) => (
            <BookingCard
              key={booking.id}
              booking={booking}
            />
          ))}
        </Flex>
      </Flex>
    </Modal>
  )
}

BookingConflictModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  bookings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      experience_name: PropTypes.string.isRequired,
      booked_date: PropTypes.string.isRequired,
      start_time: PropTypes.string.isRequired,
      client_name: PropTypes.string.isRequired,
      booking_uuid: PropTypes.string.isRequired
    })
  ).isRequired,
  crewMemberName: PropTypes.string.isRequired,
  titleKey: PropTypes.string,
  messageKey: PropTypes.string,
  closeButtonKey: PropTypes.string
}

export default BookingConflictModal
